import { createFileRoute, notFound } from "@tanstack/react-router";

import { OrganiserDialog } from "../features/organisers/components/OrganiserDialog";
import { organiserQueries } from "../features/organisers/api/queries";
import { venueQueries } from "../features/venues/api/queries";
import { areaQueries } from "../features/weather/api/queries";
import { AppHeader } from "../shared/ui/AppHeader";

export const Route = createFileRoute(
  "/_authenticated/organisers/$organiserId/edit",
)({
  loader: async ({ params, context: { queryClient } }) => {
    // No detail query — see the venue edit route on why the list is the source.
    const [data] = await Promise.all([
      queryClient.ensureQueryData(organiserQueries.list()),
      queryClient.ensureQueryData(venueQueries.list()),
      queryClient.ensureQueryData(areaQueries.list()),
    ]);
    if (
      !data.organisers.some((organiser) => organiser.id === params.organiserId)
    ) {
      throw notFound();
    }
  },
  component: EditOrganiserPage,
});

/** Chrome behind the modal; the dialog owns the form. */
function EditOrganiserPage() {
  const { organiserId } = Route.useParams();

  return (
    <>
      <AppHeader />
      <OrganiserDialog organiserId={organiserId} />
    </>
  );
}
